// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3788":"605c21a8","4421":"8e7d8608"}[chunkId] + ".chunk.css";
};